export default "/_next/static/4e023ee3de598ea4a200be08208d31ab.png";